import React from 'react';
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import IndividualPhysical from "./individual/individual-physical.jsx";
import IndividualArticles from "./individual/individual-articles.jsx";
import OccurrencePhones from "./occurrence-phones.jsx";
import IndividualAddresses from "./individual/individual-addresses.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const OccurrenceIndividual = ({data}) => {
    const individuals = data.individuals ?? []

    return (
        <>
            { individuals.map((item, index) => {

                const personalInfo = [
                    {
                        label: "CPF",
                        value: projectUtils.formatCpfToView(item?.cpf) ?? "",
                    },
                    {
                        label: "Classificação",
                        value: item?.classification ?? "",
                    },
                    {
                        label: "Nome",
                        value: item?.name ?? "",
                    },
                    {
                        label: "Nome social",
                        value: item?.socialName ?? "",
                    },
                    {
                        label: "Apelido",
                        value: item?.nickname ?? "",
                    },
                    {
                        label: "Sexo",
                        value: item?.sex ?? "",
                    },
                    {
                        label: "Estado civil",
                        value: item?.maritalStatus ?? "",
                    },
                    {
                        label: "Nome da mãe",
                        value: item?.mother ?? "",
                    },
                    {
                        label: "Nome do pai",
                        value: item?.father ?? "",
                    },
                    {
                        label: "Flagrante",
                        value: item?.flagrant ? "Sim" : "Não",
                    },
                    {
                        label: "Possui transtorno mental",
                        value: item?.mentalDisorder ? "Sim" : "Não",
                    },
                    {
                        label: "Dependência álcool/drogas",
                        value: item?.alcoholDrugDependency ? "Sim" : "Não",
                    },
                    {
                        label: "Data de nascimento",
                        value: item?.dtBirth ?? "",
                    },
                    {
                        label: "CNH",
                        value: item?.cnh ?? "",
                    },
                    {
                        label: "RG",
                        value: item?.rg ?? "",
                    },
                    {
                        label: "Emissor",
                        value: item?.emitterRg ?? "",
                    },
                ];

                const subInfo = [
                    {
                        label: "RG criminal",
                        value: item?.criminalRg ?? "",
                    },
                    {
                        label: "Nacionalidade",
                        value: item?.nationality ?? "",
                        className: 'transform -translate-x-[2px]! print:-translate-x-[7px]!'
                    },
                    {
                        label: "Naturalidade",
                        value: item?.cityOfBirth ?? "",
                        className: 'transform translate-x-[47px]! print:translate-x-[46px]!'
                    },
                    {
                        label: "Grau de instrução",
                        value: item?.educationDegree ?? "",
                    },
                    {
                        label: "Profissão",
                        value: item?.occupation ?? "",
                        className: 'transform -translate-x-[2px]! print:-translate-x-[7px]!'
                    },
                ]

                const characteristicsInfo = [
                    {
                        subTitle: "Características físicas",
                        items: [
                            {
                                label: "Cútis",
                                value: item?.color ?? "",
                            },
                            {
                                label: "Compleição",
                                value: item?.bodyShape ?? "",
                            },
                            {
                                label: "Cor dos olhos",
                                value: item?.eyes ?? "",
                            },
                            {
                                label: "Altura",
                                value: item.height != null ? item.height + 'cm' : "",
                            },
                            {
                                label: "Cumprimento dos cabelos",
                                value: item?.hairSize ?? "",
                            },
                            {
                                label: "Cor dos cabelos",
                                value: item?.hairColor ?? "",
                            },
                            {
                                label: "Tipo dos cabelos",
                                value: item?.hairType ?? "",
                            },
                        ]
                    }
                ];

                const criminalInfo = [
                    {
                        subTitle: "Histórico criminal",
                        items: [
                            {
                                label: "Função no crime",
                                value: item?.roleCrime ?? "",
                            },
                            {
                                label: "Situação",
                                value: item?.situation ?? "",
                            }
                        ]
                    }
                ];

                const individualInfo = [
                    {
                        subTitle: "Informações do indivíduo",
                        items: [
                            {
                                label: null,
                                value: item?.information ?? "",
                                valueClassName: 'ml-0!',
                                dots: false,
                                span: 3
                            }
                        ]
                    }
                ]

                return(
                    <>
                        <section className={'px-5 space-y-4!'}>
                            <h2 key={`${index}-0`} className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]! print:break-after-avoid!">
                                INDIVÍDUO - {index+1}
                            </h2>

                            <section key={`${index}-1`} className="grid grid-cols-[270px_1fr] gap-x-5 print:break-inside-avoid! mb-0!">

                                <div className={`relative bg-[#e5e5e5] w-[270px] h-[270px] mr-4 rounded ${item.relatedPhotoFaceId ? "bg-contain bg-center bg-no-repeat" : ""}`}
                                     style={{backgroundImage: `url(${API_KEEPER}/ged/attach/${item.relatedPhotoFaceId})`}}>

                                    { !item.relatedPhotoFaceId && (
                                        <span className="absolute inset-0 flex items-center justify-center font-bold text-[#4f4f4f]">
                                            [ SEM FOTO ]
                                        </span>
                                    )}
                                </div>

                                <InfoGrid key={index} title={""} items={personalInfo} columns={2} className="px-0!" labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1'}/>

                            </section>

                            <InfoGrid key={index} title={""} items={subInfo} columns={3} className="px-0!" labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1 mt-3 w-[90%]!'}/>

                            <InfoGrid key={`${index}-2`} title={""} items={characteristicsInfo} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} contentClassName={'space-y-1'} className="px-0!"/>

                            <IndividualPhysical key={`${index}-3`} item={item}/>

                            <InfoGrid key={`${index}-4`} title={""} items={criminalInfo} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'px-0!'} contentClassName={'space-y-1'}/>

                            <IndividualArticles key={`${index}-5`} item={item}/>

                            <OccurrencePhones key={`${index}-6`} data={item} type={'individual'}/>

                            <IndividualAddresses key={`${index}-7`} item={item}/>

                            { item?.information && (
                                <InfoGrid title={''} items={individualInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]'} valueClassName={'print:text-[17px]!'} className={'px-0!'} contentClassName={'space-y-1'}/>
                            )}
                        </section>
                    </>
                )
            })}
        </>
    );
};

export default OccurrenceIndividual;